import React from 'react';
import { Tooltip, Empty, Popover, Tag, Card, Timeline } from 'antd';
import { useMappedState } from 'redux-react-hook';
import moment from 'moment';
import { s3, EVENT_TYPE, EVENT_TYPE_COLOR } from './../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faUserTie } from '@fortawesome/free-solid-svg-icons'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { faInbox } from '@fortawesome/free-solid-svg-icons'
import CustomAvatar from './../components/customAvatar';
import EventBodyDisplay from './../components/eventBodyDisplay';
import ContactPopConfirm from './../components/contactPopConfirm';
import EventTypeIcon from './eventTypeIcon';
import { renderBottom } from './../utils/helper';
import { navigate } from "@reach/router"
const { groupBy, sortBy } = require('lodash');
const uuidv1 = require('uuid/v1');

function ContactEventsList(props) {
  const session = useMappedState(state => state.session);

  const data = sortBy(props.data, 'createdAt').reverse().map(i => {
    return {
      ...i,
      ...{date: `${moment(i.createdAt).format('DD-MM-YYYY')}, ${moment(i.createdAt).format('dddd')}`}
    }
  });

  const groupedData = groupBy(data, 'date');

  const dataArr = Object.keys(groupedData).map(e => {
    return {
      date: e,
      events: groupedData[e]
    }
  })

  const events = [];
  for (const item of dataArr) {
    events.push({id: uuidv1(), dateWithName: item.date});
    for (const event of sortBy(item.events, 'createdAt').reverse()) {
      const userAvatarUrl = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${event.user.id}.jpeg`;
      const newUser = {...event.user, ...{userAvatarUrl}};

      let newCandidate = event.candidate;

      if (event.candidate) {
        const candidateAvatarUrl = `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${event.candidate.id}.jpeg`;
        newCandidate = {...event.candidate, ...{candidateAvatarUrl}};
      }

      events.push({...event, ...{user: newUser}, ...{candidate: newCandidate}})
    }
  }

  const buttonDelete = (i) => {
    if (i.user.id === session.id) {
      if (props.disableRemove) {
        return(
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={`Me`}
            colourCode={i.user.firstname.charAt(0).toLowerCase()}
            char={`${i.user.firstname.charAt(0).toUpperCase()}${i.user.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            size={30}
            src={i.user.userAvatarUrl}
          />
        )
      }
      else {
        return(
          <span>
            <ContactPopConfirm event={i} contactID={props.contactID}/>
          </span>
        )
      }
    }
    return(
      <CustomAvatar
        showTooltip={true}
        tooltipTitle={`${i.user.firstname} ${i.user.lastname}`}
        colourCode={i.user.firstname.charAt(0).toLowerCase()}
        char={`${i.user.firstname.charAt(0).toUpperCase()}${i.user.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={i.user.userAvatarUrl}
      />
    )
  }

  const eventCardExtra = (i) => {
    return(
      <div>
        {buttonDelete(i)}
      </div>
    )
  }

  const candidateTitle = (i) => {
    return(
      <span>
      <CustomAvatar
        colourCode={i.candidate.firstname.charAt(0).toLowerCase()}
        char={`${i.candidate.firstname.charAt(0).toUpperCase()}${i.candidate.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        size={30}
        src={i.candidate.candidateAvatarUrl}
      />
        &nbsp;&nbsp;<span style={{fontWeight: 'normal'}}>{i.candidate.firstname} {i.candidate.lastname}</span>
      </span>
    )
  }

  const popoverCandidate = (i) => {
    return(
      <div>
        {
          !i.candidate.dob && !i.candidate.service && !i.candidate.position ?
          <i style={{color: '#cccccc'}}>No Information Available</i>
          :
          null
        }

        {
          i.candidate.dob?
          <><FontAwesomeIcon icon={faBirthdayCake} />&nbsp;<b>Birthday</b>: {moment(i.candidate.dob).format('DD-MM-YYYY')}<br/></>
          :
          null
        }
        {
          i.candidate.service?
          <><FontAwesomeIcon icon={faBriefcase} />&nbsp;<b>Service</b>: {i.candidate.service}<br/></>
          :
          null
        }
        {
          i.candidate.position?
          <><FontAwesomeIcon icon={faUserTie} />&nbsp;<b>Position</b>: {i.candidate.position}</>
          :
          null
        }
      </div>
    )
  }

  const eventCardTitle = (i) => {
    return(
      <div>
        {
          i.isEmail ?
          <span>
            <Tooltip title={`email ${i.emailType}`}>
            <FontAwesomeIcon 
              style={{cursor: 'pointer', color: '#B0BF1A'}} 
              icon={i.emailType === 'sent' ? faPaperPlane : faInbox} />&nbsp;
            </Tooltip>
          </span>
          :
          null
        }
         <EventTypeIcon event={i} />
         &nbsp;&nbsp;

        <Tag color={EVENT_TYPE_COLOR[i.type]}>{EVENT_TYPE[i.type].text}</Tag>

        {
          i.type === 'vacancy' ? 
          <span>{i.title}</span>
          : null
        }

        {
          i.candidate ?
          <Popover placement="right" content={popoverCandidate(i)} title={candidateTitle(i)}>
          <span style={{cursor: 'pointer'}} onClick={() => {
            navigate(`/candidates/${i.candidate.id}`)
          }}
          >{candidateTitle(i)}</span>
          </Popover>
          :
          null
        }
      </div>
    )
  }

  const eventCard = (i) => {
    return(
      <div style={{marginLeft: "25px", marginBottom: "25px"}}>
        <Card
          size="small"
          title={eventCardTitle(i)}
          extra={eventCardExtra(i)}
        >
        {i.body === "" ? 
          <span style={{color: '#ddd'}}>Empty body</span> 
          : 
          <EventBodyDisplay data={i.body}/>
        }
        {renderBottom(i)}
        </Card>
      </div>
    )
  }

  const renderEventRow = (i) => {
    if (!i.type) {
      return(
        <Timeline.Item
          key={i.id}
          dot={<FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '20px' }} />}
          color="blue"
        >
        <b>{i.dateWithName}</b>
        </Timeline.Item>
      )
    }
    return(
      <Timeline.Item
        key={i.id}
        dot={moment(i.createdAt).format("HH:mm")}
      >
       {eventCard(i)}
      </Timeline.Item>
    )
  }

  return (
    events.length > 0 ?
    <div style={{marginTop: '15px', marginLeft: '15px', marginRight: '5px'}}>
      <Timeline>
      {
        events.map(i => {
          return renderEventRow(i)
        })
      }
      </Timeline>
    </div>
    :
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
}

export default ContactEventsList;
